export default __webpack_public_path__ + "70fbd1c.png";